import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Modal, Transfer, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import styles from './index.scss'
import { debounce, throttle } from 'lodash'
import { levelStrategies } from 'store/LevelStore'
import { withPopover } from 'components/HOC/AntdWrapper'

const Option = Select.Option
const confirm = Modal.confirm
const initPerPage = 100
interface IStaffOperationModalProps {
  levelStore?: any
  showStaffOperation?: boolean
  toggleStaffOperation?: () => void
  activeLesson: any
  activeRole: any
  getCheckRoles: () => void
  onRef?: (ref) => void
}

interface IStaffOperationModalState {
  visible: boolean
  name: string
  targetKeys: any[]
  selectedKeys: any[]
  filter: any
  roleId: number
  departmentRoles: any[]
  departmentRolesMeta: any
}

@inject('globalStore', 'levelStore')
@observer
export default class StaffOperationModal extends ComponentExt<
  IStaffOperationModalProps,
  IStaffOperationModalState
> {
  state = {
    visible: false,
    name: '',
    roleId: 0,
    targetKeys: [],
    selectedKeys: [],
    departmentRoles: [],
    departmentRolesMeta: null,
    filter: {
      page: 1,
      per_page: 10,
    },
    departmentFilter: {
      page: 1,
      per_page: 10,
    },
  }

  handleScroll = throttle(async (direction, evt) => {
    const {
      levelStore: {
        getEntityList,
        passableStaffsMeta: {
          pagination: { count, current_page },
        },
      },
    } = this.props
    const isBottom =
      evt && evt.target
        ? evt.target.scrollHeight -
            (evt.target.scrollTop + evt.target.clientHeight) <=
          30
        : false

    if (!isBottom) {
      return false
    }

    if (direction === 'left' && count && isBottom) {
      getEntityList(
        levelStrategies.PASSABLE_STAFFS,
        {
          ...this.state.filter,
          page: current_page + 1,
        },
        'append',
      )
    }
  }, 300)

  onDepartmentRolesScroll = throttle(async (evt): Promise<any> => {
    const isBottom =
      evt && evt.target
        ? evt.target.scrollHeight -
            (evt.target.scrollTop + evt.target.clientHeight) <=
          30
        : false
    const { activeLesson } = this.props
    const {
      departmentRoles,
      departmentRolesMeta: {
        pagination: { current_page, total },
      },
    } = this.state

    if (isBottom && total > departmentRoles.length) {
      this.getDepartmentRoles(
        {
          lesson_id: activeLesson.id,
          page: current_page + 1,
          per_page: 10,
        },
        'append',
      )
    }
  }, 300)

  handleSearch = debounce(async (direction, value) => {
    const {
      levelStore: { getEntityList },
    } = this.props
    if (direction === 'left') {
      if (value) {
        this.setState({
          filter: {
            ...this.state.filter,
            staff_name: value,
          },
        })
      } else {
        // @ts-ignore
        delete this.state.filter.staff_name
      }

      await getEntityList(
        levelStrategies.PASSABLE_STAFFS,
        {
          staff_name: value,
          ...this.state.filter,
        },
        'append',
      )
    }
  }, 600)

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (prevState.activeRole !== nextProps.activeRole) {
      return {
        ...prevState,
        acitveRole: nextProps.activeRole,
        activeLesson: nextProps.activeLesson,
        filter: {
          ...prevState.filter,
          lesson_id: nextProps.activeLesson.id,
        },
      }
    }

    return null
  }

  async componentDidMount() {
    this.props.onRef(this)
  }

  async componentDidUpdate(prevProps, prevState) {}

  handleOk = async (): Promise<any> => {
    this.props.getCheckRoles()
    this.toggleVisible()
  }

  toggleVisible = async (role?) => {
    const { activeLesson } = this.props
    if (role) {
      await this.getDepartmentRoles({
        ...this.state.departmentFilter,
        lesson_id: activeLesson.id,
        role_id: role.id,
      })
    }

    this.setState({
      visible: !this.state.visible,
    })
  }

  getDepartmentRoles = async (param, mode = 'add') => {
    const res = await this.api.level.getDepartmentRoles(param)

    if (mode === 'append') {
      this.setState({
        departmentRoles: this.state.departmentRoles.concat(res.data),
        departmentRolesMeta: res.meta,
      })
    } else {
      this.setState({
        departmentRoles: res.data,
        departmentRolesMeta: res.meta,
      })
    }
  }

  handleChange = async (nextTargetKeys, direction, moveKeys) => {
    const { roleId } = this.state
    const movingStaffs = this.getPassableStaffsFromMoveKeys(moveKeys)
    const validateResult = this.validateMovingStaffs(movingStaffs)
    const {
      levelStore: { getEntityList },
      activeLesson,
    } = this.props

    const handleReuslt = async () => {
      if (direction === 'right') {
        await this.api.level.bindStaffs(roleId, {
          staff_ids: moveKeys,
        })
        this.$message.success('角色绑定成功')
      } else {
        await this.api.level.unbindStaffs({
          staff_ids: moveKeys,
        })
        this.$message.success('角色解绑成功')
      }

      this.getDepartmentRoles({
        lesson_id: activeLesson.id,
        page: 1,
        per_page: initPerPage,
      })

      getEntityList(levelStrategies.PASSABLE_STAFFS, {
        ...this.state.filter,
        lesson_id: activeLesson.id,
        page: 1,
        per_page: initPerPage,
      })
      this.setState({ targetKeys: nextTargetKeys })
    }

    if (!validateResult) {
      handleReuslt()
    } else {
      // 存在非默认角色的员工发送角色变更
      confirm({
        title: '角色变更操作',
        content:
          validateResult
            .map(staff => `${staff.staff_name}(${staff.role_name})`)
            .join('、') +
          `正在通关，${
            direction === 'right' ? '变更员工角色' : '移出'
          }将会导致本次通关失效，是否确认？`,
        onOk: async () => {
          handleReuslt()
        },
      })
    }
  }

  validateMovingStaffs = movingStaffs => {
    const ret = []
    const noValidatedList = ['未参与', '已通关', '新人', '组长', '主管']
    for (const staff of movingStaffs) {
      if (!noValidatedList.includes(staff.role_name)) {
        ret.push({
          staff_name: staff.staff_name,
          role_name: staff.role_name,
        })
      }
    }

    if (ret.length > 0) {
      return ret
    } else {
      return null
    }
  }

  getPassableStaffsFromMoveKeys = (moveKeys: number[]) => {
    const {
      levelStore: { passableStaffs },
    } = this.props
    return passableStaffs.filter(staff => moveKeys.includes(staff.staff_id))
  }

  filterOption = (inputValue, option) => {
    return option.staff_name.includes(inputValue)
  }

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
    })
  }

  onPassedRolesSelect = async role => {
    const {
      levelStore: { getEntityList },
      activeLesson,
    } = this.props
    let { departmentRoles } = this.state

    // 初始化前先请求一次
    if (departmentRoles.length === 0) {
      departmentRoles = (await this.api.level.getDepartmentRoles({
        lesson_id: activeLesson.id,
        per_page: 100,
      })).data
    }
    const departmentRole = departmentRoles.find(item => item.id === role)
    const res = await getEntityList(
      levelStrategies.PASSABLE_STAFFS,
      {
        lesson_id: departmentRole.lesson_id,
        role_id: role,
        page: 1,
        per_page: initPerPage,
      },
      'append',
    )

    const targetKeys = res.data.map(item => item.staff_id)
    this.setState({ targetKeys, roleId: role })
  }

  renderItem = (item, e) => {
    const customLabel = (
      <span>
        <span>{item.staff_name}</span>
        {!this.state.targetKeys.includes(item.staff_id) && (
          <span style={{ float: 'right' }}>
            {item.role_name && item.role_name.length > 10
              ? withPopover({
                  placement: 'bottom',
                  content: item.role_name,
                  overlayStyle: { zIndex: 10000 },
                })(<span>{item.role_name.slice(0, 10) + '...'}</span>)
              : item.role_name}
          </span>
        )}
      </span>
    )

    return {
      label: customLabel,
      value: item.id,
    }
  }

  render() {
    const {
      visible,
      targetKeys,
      selectedKeys,
      roleId,
      departmentRoles,
    } = this.state
    const {
      levelStore: { passableStaffs },
    } = this.props

    return (
      <Modal
        className={styles.staffOperationModal}
        title="人员调整"
        width={800}
        visible={visible}
        onOk={this.handleOk}
        onCancel={this.toggleVisible}
      >
        <ul className={styles.staffHeader}>
          <li style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: '50%' }}>
              可通关员工（单位全员）
            </div>
          </li>
          <li>
            <div>在通关员工列表</div>
            <Select
              value={roleId}
              placeholder="请选择角色类型"
              onPopupScroll={this.onDepartmentRolesScroll}
              style={{ width: '100%' }}
              onSelect={this.onPassedRolesSelect}
            >
              {departmentRoles &&
                departmentRoles.map(role => (
                  <Option key={role.id} value={role.id}>
                    {role.name && role.name.length > 10
                      ? withPopover({
                          placement: 'bottom',
                          content: role.name,
                          overlayStyle: { zIndex: 10000 },
                        })(<span>{role.name.slice(0, 10) + '...'}</span>)
                      : role.name}
                    {`（${role.staff_count}）`}
                  </Option>
                ))}
            </Select>
          </li>
        </ul>
        <Transfer
          dataSource={passableStaffs}
          listStyle={{
            width: 352,
            height: 300,
          }}
          rowKey={record => record.staff_id}
          // @ts-ignore
          render={this.renderItem}
          searchPlaceholder={'搜索员工姓名'}
          showSearch
          targetKeys={targetKeys}
          filterOption={this.filterOption}
          selectedKeys={selectedKeys}
          onChange={this.handleChange}
          onSelectChange={this.handleSelectChange}
          onSearch={this.handleSearch}
          onScroll={this.handleScroll}
        />
      </Modal>
    )
  }
}
